import { select } from 'd3'

/* Local */
import { CLASSES as C, CONFIG } from '../../globals/constants';
import { mappedData, rangeScale } from '../../globals/helpers';
import Card from '../Card/card'
import './style.scss';

export default class CardWrapper {
  constructor(parent, data) {
    this.parent = parent;
    this.cardArray = [] // store Card instances as member variables to be accessed from App.js
    // container for all cards
    this.cardContainer = this.parent
      .append("div")
      .attr('class', `${C.CARD}-${C.CONTAINER}`)
      .style("width", `${CONFIG.DIMS.width}px`)

    this.cardLabel = this.cardContainer
      .append("div")
      .attr("class", `${C.CARD}-${C.LABEL}`)

    this.cardLabel
      .append("div")
      .html("statement")

    this.left = this.cardLabel
      .append("div")

    this.left
      .append("div")
    // .html("treatment")

    this.domain = this.left
      .append("div")


    this.domain.append("div")
      .html("less agreement")

    this.domain.append("div")
      .html("more agreement")

    // create card for each data object
    this.cardContainer
      .selectAll(`.${C.STEP}`)
      .data(mappedData(data))
      .join('div')
      .attr('class', `${C.STEP}`)
      .each((_, i, s) => { this.cardArray.push(new Card(select(s[i]), rangeScale(data), i)) })
  }

}